import classNames from "classnames";
import { ReactNode } from "react";

import Label from "../Label/Label";
import Prose from "../Prose/Prose";

import styles from "./SectionHeader.module.css";

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  titleAs: TitleComponent = "h2",
  label,
  className,
  centered,
  description,
  descriptionNoProse,
}) => (
  <div
    className={classNames(styles.sectionHeader, className, {
      [styles.centered]: centered,
    })}
  >
    {label && <Label className={styles.label}>{label}</Label>}
    <TitleComponent className={styles.title}>{title}</TitleComponent>
    {description && !descriptionNoProse && (
      <Prose className={styles.description}>{description}</Prose>
    )}
    {description && descriptionNoProse && (
      <div className={styles.description}>{description}</div>
    )}
  </div>
);

export type SectionHeaderProps = {
  centered?: boolean;
  title: string;
  titleAs?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  label?: string;
  className?: string;
  description?: string | ReactNode;
  // Description shouldn't add Prose by default. While we review all SectionHeaders assuming Prose exists
  // we are adding this flag to allow passing components that would break under Prose
  descriptionNoProse?: boolean;
};

export default SectionHeader;
